import moment, { Moment } from 'moment';
import { weekDays } from '@data/weekDays';
import { TimeSlotConfigurationModelType } from '@models/TimeSlotConfiguration';
import { TimelineItemModelType } from '@models/TimelineItem';
import { timetable_timeslot_configuration } from '@app-types/graphql-types';
import { FormatDefaultTimeSlotConfigurationDataArgs, FormatDefaultTimeSlotConfigurationDataResults } from '../../types';
import { getTimeLineIntervalSlotsForAllGroups } from '../../helpers/getTimeLineIntervalSlotsForAllGroups';

export const formatDefaultTimeSlotConfigurationData = ({
  timeSlotConfigurations,
  week,
  timelineGroups,
}: FormatDefaultTimeSlotConfigurationDataArgs): FormatDefaultTimeSlotConfigurationDataResults => {
  const newTimeSlotConfigurations: TimeSlotConfigurationModelType[] = [];
  let timeLineIntervals: TimelineItemModelType[] = [];

  timeSlotConfigurations.forEach((timeSlotConfiguration: timetable_timeslot_configuration) => {
    // Find the iso day number. monday = 1, tuesday = 2
    const weekDayIndex = weekDays.findIndex((weekDay) => weekDay === timeSlotConfiguration.day);

    // Since this is the default config, need to replace the day stored in the data base to match the current week
    const day = week.clone().isoWeekday(weekDayIndex + 1) as Moment;
    const dbStartTime = moment(timeSlotConfiguration.startTime);
    const dbEndTime = moment(timeSlotConfiguration.endTime);

    const startTime = day.clone().set('hour', dbStartTime.hour()).set('minute', dbStartTime.minute());
    const endTime = day.clone().set('hour', dbEndTime.hour()).set('minute', dbEndTime.minute());

    if (!timeSlotConfiguration.interval) {
      newTimeSlotConfigurations.push({
        startTime,
        endTime,
      });
    } else if (timelineGroups) {
      const timeLineIntervalSlotsForAllGroups = getTimeLineIntervalSlotsForAllGroups({
        timelineGroups,
        startTime,
        endTime,
      });

      timeLineIntervals = [...timeLineIntervals, ...timeLineIntervalSlotsForAllGroups];
    }
  });

  return {
    timeLineIntervals,
    timeSlotConfigurations: newTimeSlotConfigurations,
  };
};
